import * as React from "react";
import { CommandButtonComponent } from "../../../Explorer/Controls/CommandButton/CommandButtonComponent";
import FeedbackIcon from "../../../../images/Feedback.svg";
export const FeedbackCommandButton = () => {
    return (React.createElement("div", { className: "feedbackConnectSettingIcons" },
        React.createElement(CommandButtonComponent, { id: "commandbutton-feedback", iconSrc: FeedbackIcon, iconAlt: "feeback button", onCommandClick: () => window.open("https://aka.ms/cosmosdbfeedback?subject=Cosmos%20DB%20Hosted%20Data%20Explorer%20Feedback"), ariaLabel: "feeback button", tooltipText: "Send feedback", hasPopup: true, disabled: false })));
};
